import { Input } from '../../../../components/Modules/Input'
import { LabelModule2 } from '../../../../components/Modules/LabelModule2';
import { useFeedbackWorkflow } from './FeedbackWorkflowContext'

const NormalInput = ({ question, criteriaId, placeholder, required, answer, handleUpdate }: {
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean,
    answer: any,
    handleUpdate: Function
}) => {

    const { themeManager } = useFeedbackWorkflow();
    const labelStyles = themeManager?.getLabelStyles() 
    const inputStyles = themeManager?.getInputStyles()

    return (
        <div className="" key={criteriaId}>
            <LabelModule2
                htmlFor={"normalInput"}
                children={`${question}${required === true ? "*" : ""}`}
                style={
                //     {
                //     ...themeManager?.getLabelStyles(),
                //     color:
                //         themeManager?.getLabelStyles().color,
                // }
                labelStyles
            }
            />
            <Input
                type="text"
                style={
                //     {
                //     ...themeManager.getInputStyles(),
                //     color:
                //         themeManager.getInputStyles().color,
                // }
                inputStyles
            }
                placeholder={placeholder || question}
                value={answer[criteriaId]}
                onChange={(e) => handleUpdate(e, criteriaId, "")}
                required={required}
            />
        </div>
    )
}

export default NormalInput